import { applyMiddleware, compose, createStore } from 'redux'
import { StateType } from 'typesafe-actions'
import createSagaMiddleware from 'redux-saga'
import { rootSaga } from 'sagas/index'
import config from 'config'
import storage from 'redux-persist/lib/storage'
import { createTransform, persistReducer, persistStore } from 'redux-persist'
import { QuestionState } from 'components/questions/reducer'
import hardSet from 'redux-persist/es/stateReconciler/hardSet'
import { rootReducer } from 'stores/rootReducer'

// redux-saga
const sagaMiddleware = createSagaMiddleware()

// compose alternative according to
// https://github.com/zalmoxisus/redux-devtools-extension#12-advanced-store-setup
// @ts-ignore
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

// region redux-persist

// create the set transform
const SetTransform = createTransform(
  (inboundState, key) => {
    return Object.entries(inboundState).reduce<{ [key: string]: string[] }>(
      (map, [key, answers]) => {
        if (key !== 'aryaVictims') {
          map[key] = [...answers]
        } else {
          map[key] = answers
        }
        return map
      },
      {}
    )
  },
  (outboundState, key) => {
    return Object.entries(outboundState).reduce<QuestionState>(
      (map, [key, answers]) => {
        if (key !== 'aryaVictims') {
          map[key] = new Set(answers)
        } else {
          map[key] = parseInt(answers)
        }
        return map
      },
      {}
    )
  },
  { whitelist: ['selectedAnswers'] }
)

const persistConfig = {
  key: config.articleId,
  storage,
  whitelist: ['selectedAnswers', 'submissionStatus'],
  transforms: [SetTransform],
  stateReconciler: hardSet
}

// endregion

export type RootState = StateType<ReturnType<typeof rootReducer>>
export const store = createStore(
  persistReducer(persistConfig, rootReducer),
  composeEnhancers(applyMiddleware(sagaMiddleware))
)
export const persistor = persistStore(store)

sagaMiddleware.run(rootSaga)

// region Selectors

// endregion
